import { LayoutItem } from '../../types';

const _layoutsMap = Object.freeze({
  single: {
    key: 'single',
    name: 'Single',
    layout: [{ cols: 12 }],
  },
  doubleLeading: {
    key: 'doubleLeading',
    name: 'Featured and a single aside',
    layout: [{ cols: 8 }, { cols: 4 }],
  },
  doubleTrailing: {
    key: 'doubleTrailing',
    name: 'Single aside and a Featured',
    layout: [{ cols: 4 }, { cols: 8 }],
  },
  doubleEqual: {
    key: 'doubleEqual',
    name: 'Two side by side',
    layout: [{ cols: 6 }, { cols: 6 }],
  },
  tripleLeading: {
    key: 'tripleLeading',
    name: 'Single featured and two stacked',
    layout: [{ cols: 8 }, { cols: 4, slots: 2 }],
  },
  tripleTrailing: {
    key: 'tripleTrailing',
    name: 'Two stacked and a single featured',
    layout: [{ cols: 4, slots: 2 }, { cols: 8 }],
  },
  quadruple: {
    key: 'quadruple',
    name: 'Four in a grid',
    layout: [
      { cols: 6, slots: 2 },
      { cols: 6, slots: 2 },
    ],
  },
});

type LayoutKey = keyof typeof _layoutsMap;

export const layoutsMap = _layoutsMap as unknown as Record<
  LayoutKey,
  LayoutItem
>;

export const layoutsList = Object.freeze([
  layoutsMap.single,
  layoutsMap.doubleLeading,
  layoutsMap.doubleTrailing,
  layoutsMap.doubleEqual,
  layoutsMap.tripleLeading,
  layoutsMap.tripleTrailing,
  layoutsMap.quadruple,
]);

let _uid = 0;

export function cloneLayout(layout: LayoutItem) {
  const { key } = layout;
  _uid += 1;
  return {
    ...layout,
    id: `${_uid}-${key}`,
  };
}

export function getLayoutClone(key: LayoutKey): LayoutItem | undefined {
  if (typeof key === 'string') {
    const layout = layoutsMap[key];
    if (layout) {
      return cloneLayout(layout);
    }
  }
  return undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sanitizedArrangement(input: any): LayoutItem[] | undefined {
  const result = Array.isArray(input)
    ? (input.map(value => getLayoutClone(value)).filter(v => v) as LayoutItem[])
    : undefined;
  if (result?.length) {
    return result;
  }
  return undefined;
}

export function getLayoutSlots(layouts: LayoutItem[]): number[][] | undefined {
  let idx = 0;
  return layouts.map(arr => {
    const list: number[] = [];
    arr.layout.forEach(({ slots = 1 }) => {
      for (let n = 0; n < slots; n += 1) {
        list.push(idx);
        idx += 1;
      }
    });
    return list;
  });
}
